import React, { FunctionComponent, useRef, useEffect } from 'react';
import { Presentation } from './presentation';
import { useLoginRegisterModals } from '../../../hooks/useLoginRegisterModals';

type Props = {
  embedUrl: string;
  isLoggedIn: boolean;
  lineIcon: string;
};

export const Component: FunctionComponent<Props> = ({
  embedUrl,
  isLoggedIn,
  lineIcon
}) => {
  const {
    isLoginModalOpen,
    isRegisterModalOpen,
    redirectUrl,
    isRecruitmentOrEventOrTvOrCompanyPath,
    handleToggleLoginModal,
    handleToggleRegisterModal,
    handleChangeModal,
  } = useLoginRegisterModals(false);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (isLoggedIn) return; // ログイン済みなら何もしない
    e.preventDefault();
    // モーダルを開く
    handleToggleRegisterModal();
  };

  return (
    <Presentation
      embedUrl={embedUrl}
      isLoggedIn={isLoggedIn}
      onClick={handleClick}
      isLoginModalOpen={isLoginModalOpen}
      isRegisterModalOpen={isRegisterModalOpen}
      redirectUrl={redirectUrl}
      isRecruitmentOrEventOrTvOrCompanyPath={isRecruitmentOrEventOrTvOrCompanyPath}
      handleToggleLoginModal={handleToggleLoginModal}
      handleToggleRegisterModal={handleToggleRegisterModal}
      handleChangeModal={handleChangeModal}
      lineIcon={lineIcon}
    />
  );
};
